import * as React from 'react';

import type {LeadStatus} from 'nutshell-graphql-types';

import styles from './lead-icon.module.css';

type Props = {
    id: string;
    avatarUrl: string;
    number: number | null | undefined;
    status: LeadStatus;
    height?: number;
};

export function LeadIcon(props: Props) {
    const leadIconAltText = `${props.status} lead icon`;

    return (
        <div
            style={props.height ? {height: props.height, width: props.height} : {}}
            className={styles['lead-icon']}
        >
            <img
                alt={leadIconAltText}
                src={props.avatarUrl}
                style={{height: props.height, width: props.height}}
            />
            <div
                title={`${props.number ? `Number: ${props.number}\n` : ''}ID: ${
                    props.id.split('-')[0]
                }`}
                className={styles.number}
            >
                {props.number}
            </div>
        </div>
    );
}
